import React from 'react'
import './index.scss'
import { useNavigate } from 'react-router-dom'

export const PaiementSuccessSignUP = () => {
  const navigate = useNavigate()
  return (
    <div className='paiementSuccess'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='364'
        height='364'
        viewBox='0 0 364 364'
        fill='none'
      >
        <rect width='364' height='364' rx='182' fill='#F5FBFF' />
        <g clip-path='url(#clip0_267_1509)'>
          <path
            d='M273.982 306.258L276.263 350.001C276.263 350.001 179.783 258.28 167.763 231.444C155.744 204.608 178.369 138.223 178.369 138.223L228.569 165.764L273.982 306.258Z'
            fill='#ED9DA0'
          />
          <path
            d='M126.048 119.861L111.2 121.274C111.2 121.274 103.423 138.223 127.462 139.635L126.048 119.861Z'
            fill='#ED9DA0'
          />
          <path
            d='M126.048 145.992L111.2 147.406C111.2 147.406 103.423 164.355 127.462 165.767L126.048 145.992Z'
            fill='#ED9DA0'
          />
          <path
            d='M126.048 174.24L111.2 175.653C111.2 175.653 103.423 192.602 127.462 194.014L126.048 174.24Z'
            fill='#ED9DA0'
          />
          <path
            d='M130.29 202.488L115.443 203.901C115.443 203.901 107.665 220.85 131.705 222.262L130.29 202.488Z'
            fill='#ED9DA0'
          />
          <path
            d='M118.819 126.67H119.946V95.8423C119.946 91.1102 121.828 86.5719 125.178 83.2259C128.528 79.8798 133.072 78 137.809 78H203.197C207.934 78 212.478 79.8798 215.828 83.2259C219.178 86.5719 221.06 91.1102 221.06 95.8423V264.965C221.06 267.308 220.598 269.628 219.7 271.792C218.802 273.957 217.486 275.924 215.828 277.581C214.169 279.238 212.2 280.552 210.033 281.449C207.865 282.345 205.543 282.807 203.197 282.807H137.809C135.463 282.807 133.14 282.345 130.973 281.449C128.806 280.552 126.837 279.238 125.178 277.581C123.519 275.924 122.204 273.957 121.306 271.792C120.408 269.628 119.946 267.308 119.946 264.965V148.613H118.819V126.67Z'
            fill='#3F3D56'
          />
          <path
            d='M137.088 82.6413H145.623C145.231 83.6024 145.081 84.6452 145.187 85.6778C145.293 86.7104 145.651 87.7011 146.231 88.5627C146.811 89.4242 147.594 90.1302 148.511 90.6184C149.428 91.1065 150.451 91.362 151.49 91.3622H188.951C189.99 91.362 191.013 91.1066 191.931 90.6184C192.848 90.1303 193.631 89.4243 194.21 88.5627C194.79 87.7011 195.149 86.7103 195.255 85.6777C195.361 84.645 195.211 83.6022 194.819 82.641H202.791C206.329 82.6411 209.722 84.0449 212.223 86.5436C214.725 89.0423 216.13 92.4313 216.13 95.965V264.839C216.13 268.373 214.725 271.762 212.223 274.261C209.722 276.76 206.329 278.163 202.791 278.163H137.088C133.55 278.163 130.157 276.76 127.655 274.261C125.153 271.762 123.748 268.373 123.748 264.839V95.965C123.748 92.4312 125.153 89.0421 127.655 86.5433C130.157 84.0444 133.55 82.6406 137.088 82.6406V82.6413Z'
            fill='white'
          />
          <path
            d='M181.293 129.951H158.587C157.083 129.951 155.863 131.169 155.863 132.671V134.017C155.863 135.519 157.083 136.737 158.587 136.737H181.293C182.797 136.737 184.017 135.519 184.017 134.017V132.671C184.017 131.169 182.797 129.951 181.293 129.951Z'
            fill='#2F69FE'
          />
          <path
            d='M182.633 159.111H157.246C155.742 159.111 154.522 160.329 154.522 161.831V163.177C154.522 164.679 155.742 165.897 157.246 165.897H182.633C184.137 165.897 185.357 164.679 185.357 163.177V161.831C185.357 160.329 184.137 159.111 182.633 159.111Z'
            fill='#E5E5E5'
          />
          <path
            d='M201.626 173.688H138.254C136.75 173.688 135.53 174.905 135.53 176.408V177.753C135.53 179.255 136.75 180.473 138.254 180.473H201.626C203.13 180.473 204.349 179.255 204.349 177.753V176.408C204.349 174.905 203.13 173.688 201.626 173.688Z'
            fill='#E5E5E5'
          />
          <path
            d='M201.626 188.264H138.254C136.75 188.264 135.53 189.482 135.53 190.984V192.329C135.53 193.832 136.75 195.049 138.254 195.049H201.626C203.13 195.049 204.349 193.832 204.349 192.329V190.984C204.349 189.482 203.13 188.264 201.626 188.264Z'
            fill='#E5E5E5'
          />
          <path
            d='M340.584 329.04L336.212 324.057L261.446 238.858L258.618 180.949L228.923 131.513L220.438 110.326C220.438 110.326 200.641 112.445 216.903 152.699L223.62 174.239C217.565 187.265 214.428 201.453 214.428 215.815V265.173C214.428 276.795 269.877 340.102 276.331 349.772L340.584 329.04Z'
            fill='#ED9DA0'
          />
          <path
            opacity='0.2'
            d='M222.766 135.702L228.669 132.804L228.468 132.396L223.014 135.074L214.78 113.51L214.354 113.672L222.766 135.702Z'
            fill='black'
          />
          <path
            opacity='0.2'
            d='M111.279 121.059L111.121 121.486L119.867 124.704L120.024 124.277L111.279 121.059Z'
            fill='black'
          />
          <path
            opacity='0.2'
            d='M111.281 147.488L111.123 147.916L119.868 151.134L120.026 150.706L111.281 147.488Z'
            fill='black'
          />
          <path
            opacity='0.2'
            d='M111.281 175.738L111.123 176.166L119.868 179.384L120.026 178.956L111.281 175.738Z'
            fill='black'
          />
          <path
            opacity='0.2'
            d='M115.861 203.995L115.664 204.406L119.922 206.447L120.119 206.037L115.861 203.995Z'
            fill='black'
          />
          <path
            d='M169.889 253.745C180.78 253.745 189.609 244.926 189.609 234.047C189.609 223.169 180.78 214.35 169.889 214.35C158.997 214.35 150.168 223.169 150.168 234.047C150.168 244.926 158.997 253.745 169.889 253.745Z'
            fill='#2F69FE'
          />
          <path
            d='M167.777 242.385C167.537 242.385 167.3 242.338 167.079 242.247C166.857 242.155 166.656 242.021 166.487 241.851L160.235 235.267C159.892 234.925 159.7 234.461 159.7 233.978C159.7 233.494 159.892 233.031 160.235 232.689C160.577 232.347 161.041 232.155 161.525 232.155C162.009 232.155 162.473 232.347 162.815 232.689L167.777 237.985L176.948 225.764C177.29 225.423 177.754 225.23 178.238 225.23C178.722 225.23 179.186 225.423 179.528 225.764C179.871 226.106 180.063 226.57 180.063 227.053C180.063 227.537 179.871 228 179.528 228.342L169.067 241.851C168.898 242.021 168.697 242.155 168.475 242.247C168.254 242.338 168.017 242.385 167.777 242.385Z'
            fill='#F2F2F2'
          />
        </g>
        <defs>
          <clipPath id='clip0_267_1509'>
            <rect
              width='230.584'
              height='272'
              fill='white'
              transform='translate(110 78)'
            />
          </clipPath>
        </defs>
      </svg>
      <div className='paiementSuccess-text mt-5'>
        Paiement réussi, vous êtes maintenant abonné(e).
      </div>
      <button
        className='btn-paiementSuccess mt-4'
        onClick={() => navigate('/loginClient')}
      >
        Login
      </button>
    </div>
  )
}
